<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <b-field
      :label="label"
      :type="{ 'is-danger': errors.length > 0 }"
      :message="errors[0]"
    >
      <b-select
        v-model="sizeValue"
        :placeholder="`Select a ${label}`"
        @input="$emit('input', sizeValue)"
      >
        <option v-for="size in sizes" :value="size" :key="size">
          {{ size }}
        </option>
      </b-select>
    </b-field>
  </ValidationProvider>
</template>

<script>
export default {
  inheritAttr: false,
  props: {
    label: {
      type: String,
      default: "Shirt Size"
    },
    type: {
      type: Object,
      default: null
    },
    sizes: {
      type: Array,
      default: () => {
        return ["XS", "S", "M", "L", "XL", "XXL"];
      }
    },
    value: {
      type: String,
      default: ""
    },
    rules: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      sizeValue: this.value
    };
  }
};
</script>
